import { createContext } from 'react';

import { useFlag } from '@fusion/feature-flags';

import { useAppConfigContext } from '../../providers/is-idm-provider/app-config-provider';

export interface FeatureObservationsOnIdmInterface {
  useFlag: typeof useFlag;
  useAppConfigContext: typeof useAppConfigContext;
}

const defaultValue: FeatureObservationsOnIdmInterface = {
  useFlag,
  useAppConfigContext,
};

export const FeatureObservationsOnIdmContext =
  createContext<FeatureObservationsOnIdmInterface>(defaultValue);
